import React from 'react';
import Report from './Report';

const ReportPreview: React.FC = () => (
  <Report preview />
);

export default ReportPreview;
